/* eslint-disable import/prefer-default-export */
export const AUTH_TOKEN = 'auth_token';
